export default __webpack_public_path__ + "static/media/web-designer-drawing-website-development-wireframe-68755251.48600d81.png";